export default "__VITE_ASSET__B22jZBG6__"